export const TEAMS_FR = {
    
}